import React from 'react';
import PrivatePageHOC from 'containers/PrivatPageHOC/PrivatePageHOC';
import RebaWeightContainer from './RebaWeightContainer';

const AddRebaWeight = () => {
  return <RebaWeightContainer />;
};

export default PrivatePageHOC(AddRebaWeight);
